import { LotacaoForm } from '@presentation/components/organisms'
import { AddModal } from '@presentation/components/templates'
import { AddModalProps } from '@presentation/types/components/templates'

import { validationSchema } from './shared'

type Props = {
  onAdd: () => void
}

const AddLotacaoModal: React.FC<Props> = ({ onAdd }) => {
  const modalConfigs: AddModalProps = {
    path: '/lotacoes',
    formId: 'add-lotacao',
    nameForTitle: 'Lotacao',
    validationSchema: validationSchema,
    mapRequest: data => ({
      ...data,
      responsavel_id: data.responsavel.id
    }),
    onAdd
  }

  return (
    <AddModal {...modalConfigs}>
      <LotacaoForm />
    </AddModal>
  )
}

export default AddLotacaoModal
